import React, { useState, useEffect, Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Grid, MenuItem, Select, FormControl } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import AccountBalance from "@material-ui/icons/AccountBalance";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { green } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import { Tooltip } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";

const theme = createMuiTheme({
    palette: {
        primary: green,
    },
});

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    input: {
        display: "none",
    },
    formControl: {
        margin: theme.spacing(1),
        width: "100%",
    },
}));

export default function ModalEditPayment(props) {
    const classes = useStyles();
    const { open, handleClose, payment, updatePayment } = props;

    const [form, setForm] = useState({
        id: "",
        type: "Efectivo", // "Efectivo", "Tarjeta", "Transferencia"
        amount: "",
        reference: "",
        image: null,
        preview: "",
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (payment) {
            setForm({
                id: payment.id,
                type: payment.name || "Efectivo",
                amount: payment.amount || "",
                reference: payment.reference || "",
                image: null,
                preview: payment.ticket || payment.ticketTransfer || "",
            });
        }
    }, [payment]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setForm({
                ...form,
                image: e.target.files[0],
                preview: URL.createObjectURL(e.target.files[0]),
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        updatePayment(form, () => setLoading(false));
    };

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="edit-payment-dialog"
                aria-describedby="edit-payment-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="edit-payment-dialog" style={{ textAlign: "center" }}>
                    {"Editar Pago"}
                </DialogTitle>
                <form onSubmit={handleSubmit}>
                    <DialogContent>
                        <DialogContentText id="edit-payment-description">
                            <ThemeProvider theme={theme}>
                                <Grid container spacing={2}>
                                    {/* Tipo de Pago */}
                                    <Grid item xs={12}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <InputLabel>Tipo de Pago</InputLabel>
                                            <Select
                                                label="Tipo de Pago"
                                                name="type"
                                                value={form.type}
                                                onChange={handleChange}
                                            >
                                                <MenuItem value="Efectivo">Efectivo</MenuItem>
                                                <MenuItem value="Tarjeta">Tarjeta</MenuItem>
                                                <MenuItem value="Transferencia">Transferencia</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* Monto */}
                                    <Grid item xs={12}>
                                        <TextField
                                            className={classes.margin}
                                            label="Monto"
                                            fullWidth
                                            type="number"
                                            name="amount"
                                            variant="outlined"
                                            value={form.amount}
                                            onChange={handleChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <MonetizationOn />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    {/* Referencia (Solo Transferencia) */}
                                    {form.type === "Transferencia" && (
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.margin}
                                                label="Referencia"
                                                fullWidth
                                                name="reference"
                                                variant="outlined"
                                                value={form.reference}
                                                onChange={handleChange}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <AccountBalance />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    )}

                                    {/* Imagen (Tarjeta o Transferencia) */}
                                    {(form.type === "Tarjeta" || form.type === "Transferencia") && (
                                        <Grid item xs={12}>
                                            <div style={{ textAlign: "center", marginTop: 10 }}>
                                                <input
                                                    accept="image/*"
                                                    className={classes.input}
                                                    id="edit-icon-button-file"
                                                    type="file"
                                                    onChange={handleImageChange}
                                                />
                                                <label htmlFor="edit-icon-button-file">
                                                    <IconButton
                                                        color="primary"
                                                        aria-label="upload picture"
                                                        component="span"
                                                    >
                                                        <PhotoCamera style={{ fontSize: 40 }} />
                                                    </IconButton>
                                                </label>
                                                <InputLabel>
                                                    {form.image ? "Imagen seleccionada" : "Cambiar imagen"}
                                                </InputLabel>
                                                {form.preview && (
                                                    <div style={{ marginTop: 10 }}>
                                                        <img
                                                            src={form.preview}
                                                            alt="Comprobante"
                                                            style={{ maxHeight: 200, maxWidth: "100%" }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </Grid>
                                    )}
                                </Grid>
                            </ThemeProvider>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="secondary" variant="contained">
                            Cancelar
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={loading}
                        >
                            {loading ? "Guardando..." : "Guardar Cambios"}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Fragment>
    );
}
